import Vue from "vue";
import layer from "vue-layer"
import "vue-layer/lib/vue-layer.css";
import "./vue-layer.scss"
Vue.prototype.$layer = layer(Vue);
